import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ListagemOS from './ListagemOS.vue';

export default {
  path: '/dashboards',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'listagemOS', path: 'listagemOS', component: ListagemOS },
  ],
};
